import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 231 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 231 26\" id=\"icon-right\">\r\n<path fill-rule=\"evenodd\" fill=\"\" d=\"M32.000,2.000 L32.000,-0.001 L-0.000,-0.001 L-0.000,2.000 L32.000,2.000 ZM35.000,26.000 L57.000,26.000 L58.000,26.000 L231.000,26.000 L231.000,24.000 L58.000,24.000 L57.000,24.000 L35.000,24.000 C31.133,24.000 28.000,20.866 28.000,17.000 C28.000,13.134 31.133,9.999 35.000,9.999 L39.000,9.999 L56.000,9.999 L58.000,9.999 L58.000,9.581 C59.765,8.809 61.000,7.050 61.000,5.000 C61.000,2.238 58.761,-0.001 56.000,-0.001 L39.000,-0.001 L39.000,2.000 L56.000,2.000 C57.656,2.000 59.000,3.343 59.000,5.000 C59.000,6.657 57.656,8.000 56.000,8.000 L39.000,8.000 L37.000,8.000 L35.000,8.000 C30.029,8.000 26.000,12.029 26.000,17.000 C26.000,21.970 30.029,26.000 35.000,26.000 ZM1.930,15.999 L9.000,23.070 L16.071,15.999 L9.000,8.927 L1.930,15.999 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/right.svg
// module id = 2RDt
// module chunks = 26